import { router, usePage } from '@inertiajs/vue3';
import { reactive, ref } from 'vue';
import { onAuthStateChanged } from 'firebase/auth';
// const { onAuthStateChanged } = await import('firebase/auth');
import { useCurrentUser, useFirebaseAuth } from 'vuefire';

import { locale } from '@/Localization.js';
import { updateSubscription } from './updateSubscription';

export const auth = null; // useFirebaseAuth() only exists on client side
export const user = null;

export const subscriber = ref(null);
export const partner_slug = ref(null);

export const subscription = reactive({
    app_user_id: '',
    stripe_price_id: '',
    app_user_coupon: '',
    app_user_coupon_stripe: null,
    label: '',
});

export const last_subscription_is_processing = ref(null);
export const last_subscription_is = ref('NULL');

export const childSubscription = ref(null);
export const childAuth = ref(null);

export const checkout_price_id = ref(null);
// export const setCheckoutPriceId = (val) => {
//     checkout_price_id.value = val;
// }
// export const getChechoutPriceId = () => {
//     return checkout_price_id.value;
// }
// Stripe price_id from url.
let cpid = window.location.href.match(/\/checkout\/([a-zA-Z0-9_-]+)/);
if (cpid && cpid.length) {
    cpid = cpid[1];
} else {
    cpid = null;
}
// setCheckoutPriceId(cpid);
checkout_price_id.value = cpid;

const controller = new AbortController();
export const getSubscriberLastInfos = () => {

    // console.debug('Welcome.getSubscriberLastInfos()');

    last_subscription_is_processing.value = true;

    controller.abort();

    axios.get(route('xhr.customer.subscriptions.check'), {
        signal: controller.signal
    })
        .then((response) => {
            last_subscription_is_processing.value = false;

            // ACTIVE, NOSUBSCRIPTION, EXPIRED
            last_subscription_is.value = response.data.last_subscription_is ? response.data.last_subscription_is : '';
        })
        .catch(error => {
            // If this .catch is commented, axios while throw an exception bc of the abort().
            // console.log('Error', error);
        });
};

export const getChildCoupon = () => {
    if (childSubscription
        && childSubscription.value
        && childSubscription.value.childCoupon) {
        return childSubscription.value.childCoupon;
    }
    if (childSubscription && childSubscription.childCoupon) {
        return childSubscription.childCoupon;
    }

    return null;
};

export const getChildCheckout = () => {
    if (childSubscription
        && childSubscription.value
        && childSubscription.value.childCheckout) {
        return childSubscription.value.childCheckout;
    }
    if (childSubscription && childSubscription.childCheckout) {
        return childSubscription.childCheckout;
    }

    return null;
}

export const checkout = () => {

    //  console.debug('Welcome.checkout()');

    var comp = getChildCheckout();
    if (comp) {
        return comp.submit(true);
    }

    console.error('checkout() failed', comp);
};

export const resetCheckout = () => {

    // console.debug('Welcome.resetCheckout()', { locale: locale });

    if (route().current().endsWith('.checkout')) {
        let current_route = route().current();

        // console.error('window.location.href (1)', {
        //     current_route: current_route,
        //     partner_slug: partner_slug.value,
        //     cpn: cpn.value
        // });

        if (checkout_price_id.value) {
            return false;
        }

        current_route = current_route.replace(/\.checkout$/, '.index');

        // console.error('window.location.href (2)', { current_route: current_route });

        let params = {};
        if (current_route == 'partners.default.checkout'
            || current_route == 'partners.default.index'
        ) {
            params = { partner_slug: partner_slug.value, coupon: cpn.value }; // , coupon: cpn.value?
        }

        // if (current_route == 'partners.default.index') {
        //     params.locale = locale.value;
        //     console.debug('params.locale?', { params: params });
        // }

        current_route = route(current_route, params); // partner_slug?

        // console.error('window.location.href (3)', { current_route: current_route });

        window.location.href = current_route;

        return false;
    }

    updateSubscription('stripe_price_id', '');
    var comp = getChildCheckout();
    if (comp) {
        comp.form.lookup_key = '';
        // comp.form.cancel();
        // alert('cancel (1)');
    }
};

export const resetCoupon = () => {

    //  console.debug('Welcome.resetCoupon()');

    var comp = getChildCoupon();
    if (comp) {
        comp.resetCoupon();
        // comp.form.cancel();
        // alert('cancel (2)');
    }
};

export const validateCoupon = () => {

    //  console.debug('Welcome.validateCoupon()');

    var comp = getChildCoupon();
    if (comp) {
        return comp.submit();
    }

    console.error('Welcome.validateCoupon() failed', comp);
};

const checkQsConfig = (code) => {
    if (!code) {
        return false;
    }

    return axios.post(route('xhr.coupons.config', { locale: locale, partner_slug: partner_slug.value, coupon: code }), {})
        .then(response => {
            // console.debug('Welcome.checkQsConfig()', { 'code': code, 'response': response.data });

            return response.data === true;
        })
        .catch(error => {
            console.error('axios.error')

            const data = error && error.response
                ? error.response.data
                : null;

            return error;
        });
};

export const validate_coupon_immediately = ref(null);
export const step = ref(null);
export const ssp_default = ref(null); // show_success_page_default
export const ssp = ref(null); // show_success_page
export const ssc_default = ref(null); // show_social_connexion_default
export const ssc = ref(null); // show_social_connexion
export const cpn = ref(null); // coupon_from_qs

export const goToStep = async (i, force) => {

    // console.debug('Welcome.goToStep(step)', {
    //     'step.value': step.value,
    //     i: i,
    //     force: force,
    //     partner_slug: partner_slug.value
    // });

    if (step.value === null || step.value != i || force) {

        // console.error('goToStep', i, JSON.parse(JSON.stringify(subscription)))
        // console.error('Welcome.goToStep()', i);

        step.value = i;

        // console.error('partner_slug (2)', partner_slug.value);
        if (!partner_slug.value) {
            // partner_slug.value = /([0-9a-z-]+)/.exec(window.location.pathname)[1];

            // TODO: Is user redirected to authenticated area?
            // console.error('TODO: Is user redirected to authenticated area?', {
            //     'locale': locale.value,
            //     'partner_slug': partner_slug.value,
            //     'step.value': step.value
            // });

            return false;
        }

        const partner = route().current().split('.')[1];
        // TODO: Include ssc, ssp with cpn in cpn_match_config
        const cpn_match_config = await checkQsConfig(cpn.value);

        const params = {
            'locale': locale.value,
            'partner_slug': partner_slug.value,
            step: i,
            // ssp: ssp.value,
            // ssc: ssc.value,
            cpn: cpn_match_config ? null : cpn.value
        };
        if (ssc_default.value != ssc.value) {
            params.ssc = ssc.value;
        }
        if (ssp_default.value != ssp.value) {
            params.ssp = ssp.value;
        }

        if (checkout_price_id.value) {
            return false;
        }

        const url = route(`partners.${partner}.step`, params);
        // console.error('Welcome.goToStep()', {
        //     params: params,
        //     ssc_default: ssc_default.value,
        //     ssp_default: ssp_default.value,
        //     url: url
        // });

        // console.debug('url?', url);

        router.get(url, {},
            {
                // method: 'get',
                // data: { ssp: ssp.value, ssc: ssc.value },
                // replace: true,
                preserveState: true,
                preserveScroll: true,
                // only: ['step'], // Useless?
                // headers: {},
                // errorBag: null,
                // forceFormData: false,
                // onCancelToken: cancelToken => { },
                // onCancel: () => { },
                // onBefore: visit => { },
                // onStart: visit => { },
                // onProgress: progress => { },
                // onSuccess: page => { },
                // onError: errors => { console.error('router.errors', errors) },
                // onFinish: visit => { },
            });

        // router.reload({ only: ['step'], }, { preserveState: true });
    }
};

// alert(PartnerConfig.COUPON_IS_STRIPE);

export const is_local_coupon = ref(null);
export const is_stripe_coupon = ref(null);
// const isAuthVisible = () => {
//     // childAuth;
//     var e = document.getElementById('authentication-box');
//     return e && !!(e.offsetWidth || e.offsetHeight || (e.getClientRects && e.getClientRects().length));
// }

export const updateBreadcrumb = () => {
    var newStep = step.value;

    // console.debug('Welcome.updateBreadcrumb()', {
    //     'newStep': newStep,
    //     'is_stripe_coupon': is_stripe_coupon.value,
    //     'subscription.stripe_price_id': subscription.stripe_price_id,
    //     'subscription.app_user_coupon': subscription.app_user_coupon,
    //     'subscription.app_user_id': subscription.app_user_id,
    // });

    if (newStep != 0
        && newStep != 1
        && !subscription.app_user_coupon
        && !subscription.stripe_price_id) {
        newStep = 1;
    } else if (!is_stripe_coupon.value
        && step.value != 2
        && (subscription.stripe_price_id
            || subscription.app_user_coupon)
        && !subscription.app_user_id) {
        newStep = 2;
    } else if (is_stripe_coupon.value
        && step.value != 2
        && subscription.app_user_coupon
        && !subscription.app_user_id
        && subscription.stripe_price_id) {
        newStep = 2;
    } else if (!is_stripe_coupon.value
        && newStep != 3
        && !subscription.app_user_coupon_stripe
        && !subscription.app_user_coupon
        && subscription.app_user_id
        && subscription.stripe_price_id) {
        // newStep = 3;
        checkout();
    } else if (is_stripe_coupon.value
        && newStep != 3
        && subscription.app_user_coupon_stripe
        && subscription.app_user_coupon
        && subscription.app_user_id
        && subscription.stripe_price_id) {
        // newStep = 3;
        checkout();
    } else if (newStep != 4
        && !subscription.app_user_coupon_stripe
        && subscription.app_user_coupon
        && subscription.app_user_id
        && !subscription.stripe_price_id) {
        validateCoupon();
    } else if (newStep != 5
        && subscription.app_user_coupon_stripe
        && subscription.app_user_coupon
        && subscription.app_user_id
        && subscription.stripe_price_id) {
        newStep = 5;
    }

    // console.error('newStep', newStep);
    if (newStep == 5
        && subscription.stripe_price_id
        && subscription.app_user_id
        && !is_local_coupon.value
        && !is_stripe_coupon.value) {
        // Dirty quickfix :/
        checkout();

        return false;
    }

    if (newStep >= 2) {
        if (!is_local_coupon.value
            && !is_stripe_coupon.value
            && cpn.value
            && !subscription.stripe_price_id) {
            // force_stripe_code?
            // console.error('Wrong step, stripe_price_id is missing!', {
            //     is_local_coupon: is_local_coupon.value,
            //     is_stripe_coupon: is_stripe_coupon.value,
            //     stripe_price_id: subscription.stripe_price_id
            // });

            // Cause of the dirty quickfix?
            newStep = 1;
        }
        if (is_stripe_coupon.value && !subscription.app_user_coupon) {
            newStep = 1;
        }
    }

    // console.debug('STEP:', {
    //     newStep: newStep,
    //     'step.value': step.value,
    //     is_local_coupon: is_local_coupon.value,
    //     is_stripe_coupon: is_stripe_coupon.value,
    //     stripe_price_id: subscription.stripe_price_id,
    // })

    if (step.value != newStep) {
        var previousStep = step.value;
        goToStep(newStep);
    }

    // console.error('newStep', is_stripe_coupon.value, newStep, JSON.parse(JSON.stringify(subscription)));

    // Partenamut
    if (is_stripe_coupon.value) {

        // Retrieve the first Stripe plan for subscription.
        // Note: there is only one plan for this partner.
        if (newStep <= 1 && getChildCheckout()) {
            getChildCheckout().defaultLookupKey();
        }

        if (newStep < 4
            && subscription.app_user_coupon
            && subscription.app_user_coupon_stripe
            && subscription.app_user_id) {

            previousStep = 4;
            newStep = 5;

            console.error('newStep', newStep);
        }

        if (newStep == 5) {
            if (validate_coupon_immediately.value === true) {
                checkout();
            }
            if (typeof previousStep !== 'undefined') {
                goToStep(previousStep);
            }
        }
    }
};

export const initOnAuthStateChanged = () => {

    //  console.debug('Welcome.initOnAuthStateChanged()');

    const auth = useFirebaseAuth();
    onAuthStateChanged(auth, (user) => {

        //  console.debug('Welcome.onAuthStateChanged()');

        var uid = null;
        if (user && user.uid) {
            uid = user.uid
        }
        updateSubscription('app_user_id', uid);
        updateBreadcrumb();
    });
}

export const myOnMounted = () => {

    //  console.debug('Welcome.myOnMounted()', { auth: auth, onAuthStateChanged: onAuthStateChanged });

    const user = useCurrentUser();
    updateSubscription('app_user_id', user && user.uid ? user.uid : '');
    updateBreadcrumb();

    subscriber.value = usePage().props && usePage().props.auth
        ? usePage().props.auth.subscriber
        : null;

};

